import React from 'react'

import { Typography, Tooltip } from 'antd'

import { useTheme } from 'common/hooks/use-theme'
import { Address } from 'common/server/addresses'
import { AddressTo } from 'common/server/addressesTo'

import { FlexBoxY } from './boxes'

interface FullAddressProps {
  address?: Address
  deliveryAddressTo?: AddressTo
  showDetails?: boolean
}

export const FullAddress = ({ address, showDetails, deliveryAddressTo }: FullAddressProps) => {
  const theme = useTheme()

  if (!address) {
    return <Typography.Text>Not specified</Typography.Text>
  }

  const { address_line_1, address_line_2, city, state, zip_code, phone_number, instructions, nickname } = address

  return (
    <FlexBoxY alignItems="flex-start">
      <Typography.Text ellipsis>{nickname} </Typography.Text>
      <Tooltip title={address_line_1}>
        <Typography.Text ellipsis>{address_line_1} </Typography.Text>
      </Tooltip>
      <Typography.Text ellipsis>{address_line_2} </Typography.Text>
      <Typography.Text ellipsis>
        {city}, {state} {zip_code}
      </Typography.Text>
      {showDetails && (
        <Typography.Text style={{ marginTop: '5px', color: theme.colors['gray-7'] }}>
          {phone_number}
          {instructions}
        </Typography.Text>
      )}

      {deliveryAddressTo && (
        <>
          <Typography.Text ellipsis>Attention to: {deliveryAddressTo?.name}</Typography.Text>
          <Typography.Text ellipsis>{deliveryAddressTo?.phone_number || 'Phone not provided'}</Typography.Text>
        </>
      )}
    </FlexBoxY>
  )
}

export default FullAddress
